module.exports = __webpack_public_path__ + "static/media/Jake.55e503aa.png";